export const data = [
    {
        text: "Payment methods: Skrill, Neteller, webmoney, Bank transfer",
        data: "10.02.2023"
    },
    {
        text: "Payment methods: Skrill, Neteller, webmoney, Bank transfer",
        data: "10.02.2023"
    },
    {
        text: "Payment methods: Skrill, Neteller, webmoney, Bank transfer",
        data: "10.02.2023"
    },
    {
        text: "Payment methods: Skrill, Neteller, webmoney, Bank transfer",
        data: "10.02.2023"
    },
    {
        text: "Payment methods: Skrill, Neteller, webmoney, Bank transfer",
        data: "10.02.2023"
    },
    {
        text: "Payment methods: Skrill, Neteller, webmoney, Bank transfer",
        data: "10.02.2023"
    },
];


